<template>
	<div>
		<router-view v-show="$route.matched.length==3"></router-view>
		<PageHeaderLayout v-show="$route.matched.length==2">
			<div class="main-page-content">
				<el-form :inline="true" :model="searchCondition">
					<el-form-item label="姓名">
						<el-input v-model="searchCondition.fullname" placeholder="请输入姓名" class="item-name" clearable>
						</el-input>
					</el-form-item>
					<el-form-item label="身份证号">
						<el-input v-model="searchCondition.id_number" placeholder="请输入身份证号" class="item-name" clearable>
						</el-input>
					</el-form-item>
					<el-form-item>
						<el-button type='primary' @click="searchButton">查询</el-button>
					</el-form-item>
				</el-form>

				<div class="main-table-header">
					<el-tabs v-model="activeTabName" type="card" @tab-click="tabClick">
						<el-tab-pane v-for="(item,index) in tabs" :key="index" :name='item.name' :label="item.title">
						</el-tab-pane>
					</el-tabs>
					<el-button v-if="userPermissions.includes('whiteList_add')" style="margin:0 0 20px 20px;" type="primary" size="medium" @click="AddWhiteList">
						添加白名单
					</el-button>
				</div>
				<ApeTable ref="apeTable" :data="WhiteList" :columns="columns" :loading="loadingStaus"
					:pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
					<el-table-column label="公司名称" header_align='center' align='center'>
						<template slot-scope="scope">
							<span>
								{{scope.row.company&&scope.row.company.name}}
							</span>
						</template>
					</el-table-column>
					<el-table-column label="税源地" header_align='center' align='center' v-if="activeTabName == '0'">
						<template slot-scope="scope">
							<span>
								{{(scope.row.settlement_channel&&scope.row.settlement_channel.channel_name) || '-'}}
							</span>
						</template>
					</el-table-column>
					<el-table-column label="税号" header_align='center' align='center'>
						<template slot-scope="scope">
							<span>
								{{scope.row.company&&scope.row.company.taxpayer}}
							</span>
						</template>
					</el-table-column>
					<el-table-column label="类型" header_align='center' align='center' v-if="activeTabName != 2">
						<template slot-scope="scope">
							<span>
								{{(scope.row.type=='0' || scope.row.type=='3') ?'个人白名单' :'全公司白名单' }}
							</span>
						</template>
					</el-table-column>
					<el-table-column  width="160" header_align='center' align='center'
						label="操作">
						<template slot-scope="scope">
							<span>
								<el-popover placement="top" width="150" v-model="scope.row.visible">
									<p>确定要删除记录吗？</p>
									<div style="text-align: right; margin: 0;">
										<el-button type="text" size="mini" @click="scope.row.visible=false">取消
										</el-button>
										<el-button type="danger" size="mini" @click="deleteWhiteList(scope.row.id)">确定
										</el-button>
									</div>
									<el-button type="danger" slot="reference" v-if="userPermissions.includes('whiteList_delete')">删除</el-button>
								</el-popover>
							</span>
						</template>
					</el-table-column>
				</ApeTable>
			</div>
		</PageHeaderLayout>
		<add-white-list :activeTabName='activeTabName' ref='addWhiteList' @refresh='init' :searchDataList='companyList'></add-white-list>
	</div>
</template>

<script>
	import PageHeaderLayout from '@/layouts/PageHeaderLayout'
	import ApeTable from '@/components/ApeTable'
	import addWhiteList from './addWhiteList.vue'
	import {
		mapGetters,
	} from 'vuex'

	export default {
		components: {
			PageHeaderLayout,
			ApeTable,
			addWhiteList
		},
		data() {
			return {
				activeTabName: '0',
				tabs: [{
						title: '年龄白名单',
						name: '0',
					},
					{
						title: '限额白名单',
						name: '1',
					},
					{
						title:'充值白名单',
						name:'2'
					}
				],
				companyList: [], //公司列表
				// 搜索条件
				searchCondition: {
					fullname: '',
					id_number: ''
				},
				loadingStaus: true,
				columns: [
					{
						title: '姓名',
						value: 'fullname',
						width: 170,
						header_align: 'center',
						align: 'center',
					},
					{
						title: '身份证号',
						value: 'id_number',
						width: 170,
						header_align: 'center',
						align: 'center',
					},
				],
				// 表格列表数据
				WhiteList: [],
				// 分页信息
				pagingData: {
					is_show: true,
					layout: 'total, sizes, prev, pager, next, jumper',
					total: 0
				},
				// 分页的offset,序号列使用
				offset: 0,
			}
		},

		computed: {
			...mapGetters(['userPermissions']),
		},
		watch: {
			"$route.matched": function(n) {
				if (n.length === 2) {
					this.init()
				}
			}
		},
		methods: {
			// 搜索
			searchButton() {
				this.init()
			},
			// 切换页码操作
			async switchPaging() {
				this.init()
			},
			// 添加白名单
			async AddWhiteList() {
				
				this.$refs.addWhiteList.open()
			},
			// 获取公司列表
			async getCompanyList() {
				let res = await this.$api.getUserCompanyList()
				this.companyList = res || []
			},
			// 删除白名单
			async deleteWhiteList(id) {
				let res=null
				if (this.activeTabName == '0') {
					//年龄
					res = await this.$api.deleteAgewhiteId(id)
				} else if(this.activeTabName == '1'){
					//限额
					res = await this.$api.deleteQuotaWhiteId(id)
				}else{
					res = await this.$api.delrechargewhiteList(id)
				}
				if (res) {
					this.$message({
						message: `删除成功`,
						type: 'success'
					});
					this.init()
				}
			},
			replaceStr(str) {
				const middleValue = str.substring(4, 14)
				return str = `****${middleValue}****`
			},
			tabClick() {
				this.init()
				if(this.activeTabName == '2'){
					this.columns = []
				}else{
					this.columns = [
						{
							title: '姓名',
							value: 'fullname',
							width: 170,
							header_align: 'center',
							align: 'center',
						},
						{
							title: '身份证号',
							value: 'id_number',
							width: 170,
							header_align: 'center',
							align: 'center',
						},
					]
				}
			},
			// 初始化列表
			async init() {
				let pagingInfo = this.$refs['apeTable'].getPagingInfo() || {
					page_size: 10,
					current_page: 1
				}
				this.loadingStaus = true
				this.WhiteList=[]
				let res = null
				if (this.activeTabName == '0') {
					//年龄
					res = await this.$api.postAgewhiteList({
						...this.searchCondition,
						...pagingInfo
					})
				} else if(this.activeTabName == '1'){
					//限额
					res = await this.$api.postQuotawhiteList({
						...this.searchCondition,
						...pagingInfo
					})
				} else {
					// 充值白名单
					res = await this.$api.rechargewhiteList({
						// ...this.searchCondition,
						...pagingInfo
					})
				}
				this.WhiteList = res.data || []
				this.$nextTick(() => {
					this.loadingStaus = false
				})
				this.pagingData.total = res.pages.total
				this.offset = res.pages.offset
			},
		},
		mounted() {
			this.init()
			//获取公司列表
			this.getCompanyList()
		},
	}
</script>

<style lang="scss" scoped>
	.main-page-content {
		position: relative
	}

	.main-table-header {
		display: flex;
		justify-content: space-between;
		padding-right: 20px;
		box-sizing: border-box;
	}
</style>
